import { render, staticRenderFns } from "./activityFlowfabu.vue?vue&type=template&id=46467e61&"
import script from "./activityFlowfabu.vue?vue&type=script&lang=js&"
export * from "./activityFlowfabu.vue?vue&type=script&lang=js&"
import style0 from "./activityFlowfabu.vue?vue&type=style&index=0&id=46467e61&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports